// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__vuiTD","requiredAsterisk":"Info_requiredAsterisk__2EEZU"};